import { matchPath, useLocation } from "react-router-dom"

export function useRouteMatch(patterns: readonly string[]): string | undefined {
  const { pathname } = useLocation()
  return patterns.find((pattern) => matchPath(pattern, pathname)?.pattern.path)
}
